export const CHAT_NOTIFICATION_CATEGORIES = ["message", "mention"];
